export default __webpack_public_path__ + "a3fa7d98830af0c82f16fd09881ed9dd.png";